export default __webpack_public_path__ + "static/media/lilly.aea6b2a4.png";